/**
 * 功能: 全局页面渲染
 */
<template lang="pug">
  div#app
    router-view(v-if="isRouterAlive")
</template>

<script>
export default {
  data () {
    return {
      isRouterAlive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  mounted () {
    // window.addEventListener('hashchange', () => {
    //   var currentPath = window.location.hash.slice(1) // 获取输入的路由
    //   if (currentPath === '/login') {
    //     location.reload()
    //   }
    // }, false)
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">
.el-popover{
  height: 98vh;
  overflow: auto;
}
</style>
